import React from 'react';
import { Wrapper } from './ActionsBar.styles';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { useKey } from '../../hooks/useKey';
import ArrowLeftKeySymbol from '../../../img/arrow-left-key-symbol.svg';
import { KeyboardShortcut } from '../../Survey.styles';

interface Props {
  isMobile: boolean;
  handleOnBack: () => void;
  isFirstQuestion: boolean;
}

export const ActionsBar = ({ isMobile, isFirstQuestion, handleOnBack }: Props) => {
  useKey('ArrowLeft', handleOnBack);

  return (
    <Wrapper as="section">
      <Button
        variant={isMobile ? 'link' : 'secondary'}
        leftIcon={isMobile ? 'fas fa-chevron-left' : undefined}
        onClick={handleOnBack}
        rightAddon={
          <KeyboardShortcut>
            <ArrowLeftKeySymbol />
          </KeyboardShortcut>
        }
      >
        {isFirstQuestion ? 'Start Over' : `Change ${!isMobile ? 'Last ' : ''}Answer`}
      </Button>
    </Wrapper>
  );
};
